import { App, localTable, router } from "@eusoft/webapp-framework";
import { MainPage } from "./pages/MainPage";
import { apiClient } from "./services/ApiClient";
import ENV from "environment";
import { OPERATION_MANAGER, OperationManager } from "@eusoft/webapp-ui";
import { Services } from "@eusoft/webapp-core";

export class VcApp extends App {

    protected override async onStarted() {

        console.log(ENV);

        Services[OPERATION_MANAGER] = new OperationManager();

        apiClient.endpoint = ENV == "development" ? "https://localhost:7126/api/latest/" : "/api/latest/";

        localTable.language = "IT";

        router.addPage(MainPage);

        router.startAsync();
    }
}